module.exports = __webpack_public_path__ + "static/media/golfer-7-b.88a38b88.png";